import { createContext, useContext } from 'react';

export interface AppShellLayoutContextValue {
  setSidebarReservation: (width: number) => void;
}

export const AppShellLayoutContext = createContext<AppShellLayoutContextValue | null>(null);

export function useAppShellLayout() {
  const context = useContext(AppShellLayoutContext);
  if (!context) {
    throw new Error('useAppShellLayout must be used inside AppShellLayoutContext');
  }
  return context;
}
